module.exports = __webpack_public_path__ + "static/media/publisher-book.bc922642.svg";